import React from 'react';
import { Box } from '@mui/material';
import { Text, TextTitle } from '../../../Text';
import DeleteButton from '../../../Buttons/DeleteButton';
import CustomInput from '../../../Inputs';
import AddButton from '../../../Buttons/AddButton';
import {
  EQUIPMENTS_NAME,
  getInitialTechnology,
  MANUFACTURED_PRODUCTS_NAME,
  MONITORING_KINDS_NAME,
  SECONDARY_PRODUCTS_NAME,
  TECHNOLOGIES_NAME,
  WASTE_ITEMS_NAME,
} from '../../../../constants/lkCadastr/cadastrForm7';
import {
  flexGap2,
  flexRowGap2,
  fullWidth,
  SCROLL_CONTAINER_SX,
} from '../../../../constants/lkCadastr/cadastrStorage';
import { Equipments } from './Equipments';
import { WasteItems } from './WasteItems';
import { ManufacturedProducts } from './ManufacturedProducts';
import { SecondaryProducts } from './SecondaryProducts';
import { MonitoringKinds } from './MonitoringKinds';
import NavTabs from '../../../Tabs';
import useCadastreTabs from '../../../../hooks/useCadastreTabs';
import CustomAccordion from '../../../CustomAccordion';
import { deleteForm7Entity } from '../../../../helpers/cadastreForms/form7Helper';

export function Technologies({
  technologies, changeItem, isDemo, openDeleteModal,
}) {
  const { tab, tabs, setTab } = useCadastreTabs({ items: technologies, tabName: 'Технология' });

  return (
    <>
      <Box sx={flexRowGap2}>
        <TextTitle h3>Технологии</TextTitle>
        {!isDemo && (
          <AddButton
            variant="outlined"
            onClick={() => changeItem(TECHNOLOGIES_NAME, [...technologies, getInitialTechnology()])}
          >
            Добавить технологию
          </AddButton>
        )}
      </Box>
      <NavTabs tabsComponents={tabs} tab={tab} setTab={setTab} />
      <Box sx={{ ...SCROLL_CONTAINER_SX, height: '55vh' }}>
        {technologies.map((technology, technologyIndex) => {
          if (tab !== technology.randId) return null;

          const changeTechnology = (field, value, type, innerIndexProp) => changeItem(
            `${TECHNOLOGIES_NAME}.${technologyIndex}.${field}`,
            value,
            type,
            {
              technologyIndex,
              ...innerIndexProp,
            },
          );

          const onDeleteTechnology = async () => {
            if (technology?.id) {
              const deletedTechnology = await deleteForm7Entity({ id: technology.id, apiType: TECHNOLOGIES_NAME });

              if (!deletedTechnology) return;
            }

            const cloneArray = technologies.slice();
            cloneArray.splice(technologyIndex, 1);

            changeItem(
              TECHNOLOGIES_NAME,
              cloneArray,
              'delete',
            );
          };

          return (
            <Box key={technology.randId} sx={flexGap2}>
              <Box display="flex" alignItems="center" mb={1} gap={3}>
                {!isDemo && technologies.length > 1 && (
                  <DeleteButton onClick={() => openDeleteModal(onDeleteTechnology, technologyIndex, 'Технологию')}>
                    Удалить технологию
                  </DeleteButton>
                )}
              </Box>
              <Box>
                <Text className="mute">Наименование технологии</Text>
                <CustomInput
                  validImmediately
                  debounceTime={0}
                  disabled={isDemo}
                  value={technology.name}
                  onChange={(e, value) => changeTechnology('name', value)}
                  sx={fullWidth}
                />
              </Box>
              <Box>
                <Text className="mute">Краткое описание технологии</Text>
                <CustomInput
                  validImmediately
                  debounceTime={0}
                  disabled={isDemo}
                  value={technology.short_description}
                  onChange={(e, value) => changeTechnology('short_description', value)}
                  sx={fullWidth}
                />
              </Box>
              <Box sx={flexGap2}>
                <TextTitle h3>Назначение объекта</TextTitle>
                <CustomAccordion title="Используемые установки">
                  <Equipments
                    isDemo={isDemo}
                    openDeleteModal={openDeleteModal}
                    equipments={technology[EQUIPMENTS_NAME]}
                    changeItem={changeTechnology}
                  />
                </CustomAccordion>
                <CustomAccordion title="Обрабатываемые/обезвреживаемые/утилизируемые отходы">
                  <WasteItems
                    isDemo={isDemo}
                    openDeleteModal={openDeleteModal}
                    wasteItems={technology[WASTE_ITEMS_NAME]}
                    changeItem={changeTechnology}
                  />
                </CustomAccordion>
                <CustomAccordion title="Производимая продукция">
                  <ManufacturedProducts
                    isDemo={isDemo}
                    openDeleteModal={openDeleteModal}
                    manufacturedProducts={technology[MANUFACTURED_PRODUCTS_NAME]}
                    changeItem={changeTechnology}
                  />
                </CustomAccordion>
                <CustomAccordion title="Отходы, образующиеся после обработки, утилизации, обезвреживания">
                  <SecondaryProducts
                    isDemo={isDemo}
                    openDeleteModal={openDeleteModal}
                    secondaryProducts={technology[SECONDARY_PRODUCTS_NAME]}
                    changeItem={changeTechnology}
                  />
                </CustomAccordion>
                <CustomAccordion title="Виды мониторинга окружающей среды на объекте">
                  <MonitoringKinds
                    isDemo={isDemo}
                    openDeleteModal={openDeleteModal}
                    monitoringKinds={technology[MONITORING_KINDS_NAME]}
                    changeItem={changeTechnology}
                  />
                </CustomAccordion>
              </Box>
            </Box>
          );
        })}
      </Box>
    </>
  );
}
